import React from 'react';

const uid = 'gutoSignInBanner';

export default function GutoBannerLogo() {
  return (
    <svg
      width="480"
      viewBox="0 0 952 248"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      style={{ position: 'relative', marginBottom: 32, maxWidth: '100%', height: 'auto' }}
    >
      <g clipPath={`url(#${uid}-clip)`}>
        <path
          d="M115 19C89.8044 19 65.6408 30.4839 47.8249 50.9254C30.0089 71.3668 20 99.0914 20 128C20 156.909 30.0089 184.633 47.8249 205.075C65.6408 225.516 89.8044 237 115 237"
          stroke="white"
          strokeWidth="36"
        />
        <path d="M205.996 116.609H168.996V255.609H205.996V116.609Z" fill="white" />
        <path d="M205.996 116.609H102.996V160.609H205.996V116.609Z" fill="white" />
        <path
          d="M267 0V157.218C267 178.377 274.428 198.67 287.649 213.632C300.87 228.594 318.802 237 337.5 237C356.198 237 374.13 228.594 387.351 213.632C400.572 198.67 408 178.377 408 157.218V0"
          stroke="white"
          strokeWidth="36"
        />
        <path d="M626.843 0H453V38.8174H626.843V0Z" fill="white" />
        <path d="M559 19H522V248H559V19Z" fill="white" />
        <path
          d="M666 19.4211C667.276 6.47368 699.181 0 761.714 0C831.905 0 867 27.3333 867 82V224.421C867 238.807 859.343 246 844.029 246H688.971C673.657 246 666 238.807 666 224.421V19.4211Z"
          fill="white"
        />
        <path
          d="M684.652 34.4563C685.928 24.1521 711.435 19 761.174 19C822.391 19 853 39.6084 853 80.8252V204.476C853 213.492 846.623 218 833.87 218H694.217C682.739 218 677 213.492 677 204.476L684.652 34.4563Z"
          fill="#1A2E58"
        />
        <mask
          id={`${uid}-mask`}
          maskType="luminance"
          maskUnits="userSpaceOnUse"
          x="636"
          y="-57"
          width="259"
          height="305"
        >
          <path
            d="M647.261 -33.3107C649.138 -49.1036 686.674 -57 759.87 -57C849.957 -57 895 -25.4142 895 37.7573V227.272C895 241.091 885.616 248 866.848 248H661.337C644.446 248 636 241.091 636 227.272L647.261 -33.3107Z"
            fill="white"
          />
        </mask>
        <g mask={`url(#${uid}-mask)`}>
          <path
            d="M795.408 209.761C796.477 198.117 826.432 170.964 845.803 162.797"
            stroke="#51678D"
            strokeWidth="11.886"
          />
          <path
            d="M721.941 188.951L723.762 184.576H684.702L693.133 152.44C694.562 146.966 697.789 142.119 702.305 138.664C706.821 135.209 712.37 133.341 718.075 133.357L791.03 133.95L796.642 167.396L782.251 170.905C786.382 175.607 789.15 181.331 790.257 187.468L790.557 188.951H721.941Z"
            fill="#51678D"
          />
          <path
            d="M718 134.593L789.908 135.186L795.146 166.481L779.881 170.189L781.079 171.549C785.151 176.12 787.877 181.712 788.961 187.715H723.812L725.633 183.29H686.324L694.33 152.811C695.694 147.618 698.757 143.018 703.04 139.735C707.324 136.452 712.585 134.669 718 134.667V134.593ZM718 132.195C712.032 132.2 706.235 134.166 701.514 137.785C696.794 141.403 693.416 146.47 691.911 152.193L683.904 182.672L683.081 185.737H686.299H721.891L721.492 186.677L720.046 190.113H791.978L791.405 187.146C790.374 181.47 787.969 176.126 784.396 171.573L795.745 168.804L797.99 168.261L797.615 165.986L792.353 134.716L792.003 132.665H789.908L718.15 132.121L718 132.195Z"
            fill="#1A2E58"
          />
          <path
            d="M776.065 205.983H793.525C790.142 201.395 785.909 197.486 781.054 194.464C777.686 192.521 773.925 191.346 770.043 191.02C766.161 190.695 762.254 191.23 758.606 192.585L714.459 204.277L722.39 185.515H685.8L677.719 216.266C676.636 220.357 676.779 224.673 678.132 228.685C679.485 232.696 681.989 236.23 685.337 238.853C688.685 241.476 692.732 243.075 696.983 243.453C701.234 243.833 705.504 242.975 709.27 240.986L729.224 230.529C746.683 221.235 775.617 206.378 775.916 206.23L776.065 205.983Z"
            fill="#FFF38F"
            stroke="#1A2E58"
            strokeWidth="0.566"
            strokeMiterlimit="10"
          />
          <path
            d="M845.97 135.646H791.064L796.267 165.733L849.278 153.334L845.97 135.646Z"
            fill="#FFF38F"
            stroke="#1A2E58"
            strokeWidth="0.566"
            strokeMiterlimit="10"
          />
          <path
            d="M771.975 76.9963V76.6008C771.975 76.2547 771.975 75.9086 771.975 75.5872C771.956 75.2861 771.822 75.0031 771.601 74.7962C768.285 71.7918 764.334 69.5592 760.036 68.2611C755.738 66.9632 751.202 66.6324 746.759 67.2933C742.316 67.9542 738.078 69.59 734.353 72.0812C730.63 74.5724 727.514 77.8562 725.233 81.693C725.079 81.9766 725.03 82.3047 725.094 82.6205C725.158 82.9364 725.33 83.2203 725.583 83.4234C727.41 84.9578 729.452 86.2232 731.644 87.1807C731.945 87.2849 732.273 87.2908 732.578 87.1973C732.883 87.104 733.15 86.9162 733.34 86.6616C737.691 81.3791 743.678 77.6659 750.374 76.0973C757.07 74.5287 764.101 75.1922 770.378 77.9851C770.551 78.0759 770.745 78.1235 770.94 78.1235C771.136 78.1235 771.328 78.0759 771.501 77.9851C771.667 77.8825 771.8 77.7348 771.885 77.5595C771.968 77.3843 772 77.1888 771.975 76.9963Z"
            fill="#51678D"
            stroke="#1A2E58"
            strokeWidth="0.566"
            strokeMiterlimit="10"
          />
          <path
            d="M742.169 125.199C749.379 125.199 756.295 122.36 761.393 117.307C766.491 112.254 769.356 105.401 769.356 98.255V78.6525C763.342 76.1074 756.657 75.5701 750.308 77.1219C743.959 78.6738 738.293 82.2303 734.163 87.2548C733.916 87.5666 733.602 87.8195 733.244 87.9949C732.886 88.1703 732.492 88.2638 732.092 88.2683C731.792 88.2733 731.495 88.2142 731.22 88.0952C728.913 87.1226 726.775 85.7962 724.884 84.1649C724.429 83.8124 724.112 83.3144 723.986 82.7558C720.748 80.9411 717.771 78.7047 715.132 76.1063C715.032 77.0341 714.982 77.9665 714.982 78.8996V98.255C714.982 105.401 717.846 112.254 722.945 117.307C728.043 122.36 734.959 125.199 742.169 125.199Z"
            fill="#FFF38F"
          />
        </g>
      </g>
      <defs>
        <clipPath id={`${uid}-clip`}>
          <rect width="952" height="248" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
